import { View, Text } from "@react-pdf/renderer";
import { abnNoticeConstants } from "constants/abnNotice";
import { useMemo } from "react";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

export function Options({ activeAbnNotice }: { activeAbnNotice: IAbnNotice }) {
  const options = useMemo(() => {
    const allOptions =
      activeAbnNotice?.documentSnapshot?.availableOptions || [];
    // CMS requires the decline option to be Option 3. Match on value rather than on the
    // label text, which changes whenever CMS revises the form (CLE-2659).
    const declineOption = allOptions.find(
      (option: any) =>
        option.value === abnNoticeConstants.abnOption.declineService
    );
    if (!declineOption) return allOptions;

    return [
      ...allOptions.filter((option: any) => option !== declineOption),
      declineOption,
    ];
  }, [activeAbnNotice]);
  const selectedOptionValue = useMemo(() => {
    return activeAbnNotice?.documentSnapshot?.selectedOption?.value;
  }, [activeAbnNotice]);
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: 5,
      }}
    >
      <Text
        style={{
          ...styles.bodyText,

          fontFamily: "Helvetica-Bold",
          marginBottom: 3,
        }}
      >
        What to do now
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 12, marginBottom: 0 }}>
        • Read this notice to make an informed decision about your care.
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 12, marginBottom: 0 }}>
        • Ask any questions you may have.
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 12, marginBottom: 0 }}>
        • Choose one option below to let us know if you still want to get the
        item, test, service or care.
      </Text>
      <View style={{ display: "flex", flexDirection: "row", gap: 1 }}>
        <Text
          style={{
            ...styles.bodyText,
            fontSize: 12,
            fontFamily: "Helvetica-Bold",
          }}
        >
          Note:{" "}
        </Text>
        <Text
          style={{
            ...styles.bodyText,
            fontSize: 12,
            marginBottom: 0,
            marginRight: 30,
          }}
        >
          {activeAbnNotice?.documentSnapshot?.note ||
            `If you choose Option 1 or 2, we may help you use any other insurance you might have, but Medicare can't require us to do this.`}
        </Text>
      </View>
      <View
        style={{
          borderWidth: 1,
          borderColor: "#000",
          marginTop: 8,
        }}
      >
        {/* Header row */}
        <View
          style={{
            flexDirection: "row",
            backgroundColor: "#f0f0f0",
            borderBottomWidth: 1,
            borderColor: "#000",
          }}
        >
          <Text
            style={{
              ...styles.bodyText,
              fontFamily: "Helvetica-Bold",
              fontSize: 11,
              padding: 3,
              marginBottom: 0,
            }}
          >
            Choose ONE option below. We can&apos;t choose for you.
          </Text>
        </View>

        {/* Options list */}
        {options.map((option: any, index: number) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              alignItems: "flex-start",
              padding: 4,
              borderBottomWidth: index === options.length - 1 ? 0 : 0,
            }}
          >
            {/* Radio circle */}
            <View
              style={{
                width: 10,
                height: 10,
                borderWidth: 1,
                borderColor: "#000",
                borderRadius: 5,
                marginRight: 4,
                marginTop: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {option.value === selectedOptionValue && (
                <View
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: "#000",
                  }}
                />
              )}
            </View>

            {/* Option text */}
            <Text
              style={{
                ...styles.bodyText,
                fontSize: 11,
                marginBottom: 0,
                flex: 1,
              }}
            >
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                }}
              >
                {`Option ${index + 1}: `}
              </Text>
              {option.label}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}
